export default "__VITE_ASSET__CuQIauOZ__"